<div style="position:relative;" data-cy="image-picker-container-div">
  <div *ngIf="showLabel === true"
    style="font-size: 11px; color: grey; opacity: 0.7; font-family: Roboto,serif; letter-spacing: 1px;" data-cy="image-picker-label-div">Image</div>
  <div style="position: relative; width: 40px;" data-cy="image-picker-button-container-div">
    <button id="btnZPopover" *ngIf="selectedImage === '' || selectedImage === null || selectedImage === undefined"
      (click) = "onIconButtonClick()"
      matTooltip="Select image" style="color: var(--tdo-purple); width: 100%; height: 100%;"
      data-cy="image-picker-select-image-button">
      <mat-icon data-cy="image-picker-select-image-icon">image</mat-icon>
    </button>
    <button id="btnZPopover" *ngIf="selectedImage !== '' && selectedImage !== null && selectedImage !== undefined"
      (click) = "onIconButtonClick()"
      matTooltip="Select image" style="color: var(--tdo-purple); width: 100%; height: 100%;"
      data-cy="image-picker-selected-image-button">
      <img [src]="selectedImage" data-cy="image-picker-selected-image-img"/> 
    </button>
  </div> 

<!--  
 
   <dx-popover target="#btnZPopover"   
      position="top" 
      [width]="300" 
      [height]="500"  
      [showTitle]="true"
      title="TDO Icons"   
      showEvent="mouseenter"
      hideEvent="mouseleave" >
    <div *dxTemplate="let data = model of 'content'">
      <div class="tdo-image-picker-main" [style.height]="popoverHeight"  [style.left]="0" [style.top]="0">
        <div class="image-picker-action" (click)="onImageRemoveClick('')">
          Remove current
        </div>
        <div [style.height.px]="popoverHeight - 40" class="tdo-image-picker-grid">
          <div *ngFor="let imageSrc of dataSource" class="grid-item">
            <button (click)="onImageClick(imageSrc)">
               <img [src]="path + imageSrc" />  
                <img src="assets/Images/image-picker/iconMicroscope.svg" /> 
              
            </button>
          </div>
        </div>
      </div>
    </div>
  </dx-popover>  -->

</div>
 

<!-- <img src="assets/Images/image-picker/iconMicroscope.svg" /> -->